export enum State {
  AntarcticTerritories = '984',
  ClippertonIsland = '989',
  FrenchPolynesia = '987',
  NewCaledonia = '988',
  SaintBarthelemy = '977',
  SaintMartin = '978',
  SaintPierre = '975',
  WallisAndFutuna = '986'
}
